/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { TextInput } from 'src/components/ts-components/TextInput'

interface NumberRangeInputsProps {
  min: string
  max: string
  onMinChange: (value: string) => void
  onMaxChange: (value: string) => void
  fieldErrors?: any
  customError?: any
}

const NumberRangeInputs = ({
  min,
  max,
  onMinChange,
  onMaxChange,
  fieldErrors = {},
  customError = {},
}: NumberRangeInputsProps) => {
  return (
    <div
      css={css`
        display: flex;
        gap: 16px;
        align-items: flex-start;
      `}
    >
      <div
        css={css`
          flex: 1 1 0;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          gap: 8px;
          display: inline-flex;
        `}
      >
        <TextInput
          name='number-min'
          value={min}
          setValue={onMinChange}
          fieldErrors={fieldErrors}
          customError={customError}
          label='Minimum Value'
          placeholder='Enter minimum value (optional)'
          type='number'
        />
      </div>
      <div
        css={css`
          flex: 1 1 0;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          gap: 8px;
          display: inline-flex;
        `}
      >
        <TextInput
          name='number-max'
          value={max}
          setValue={onMaxChange}
          fieldErrors={fieldErrors}
          customError={customError}
          label='Maximum Value'
          placeholder='Enter maximum value (optional)'
          type='number'
        />
      </div>
    </div>
  )
}

export default NumberRangeInputs
